<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <select name="book_type" id="book_type" class="form-control form-control-lg" v-model="book_type">
                        <option value="items_book">Inventāra grāmata</option>
                        <option value="acts_book">Aktu par priekšmetu pieņemšanu muzeja īpašumā reģistrācijas grāmata</option>
                        <option value="special_made_act_book">Muzeja pasūtījumā izgatavoto priekšmetu aktu reģistrācijas grāmata</option>
                        <option value="from_private_and_public_institution_received_book">No privātām un publiskām institūcijām pārņemto priekšmetu aktu reģistrācijas grāmata</option>
                        <option value="gift_agreement_book">Dāvinājuma līgumu reģistrācijas grāmata</option>
                        <option value="purchase_agreement_book">Pirkuma līgumu reģistrācijas grāmata</option>
                        <option value="external_movement_book">Aktu par priekšmetu izsniegšanu uz laiku ārpus muzeja un deponējumu līgumu reģistrācijas grāmata</option>
                        <option value="temp_items_acts_books">Aktu par priekšmetu pieņemšanu uz laiku un deponējumu līgumu reģistrācijas grāmata</option>
                        <option value="internal_movement_book_give">Aktu par priekšmetu izsniegšanu uz laiku muzejā reģistrācijas grāmata</option>
                        <option value="existence_act_book">Aktu par esības pārbaudi reģistrācijas grāmata</option>
                        <option value="restored_items_book">Konservēto un restaurēto priekšmetu reģistrācijas grāmata</option>
                        <option value="eliminated_items_act_book">No krājuma atsavināto priekšmetu aktu reģistrācijas grāmata</option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <hr>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-2" v-if="book_type == 'items_book'">
                        <label for="ciphers">Šifri</label>
                        <v-select
                            :multiple="true"
                            v-model="ciphers"
                            :options="item_ciphers"
                            :reduce="cipher => cipher.title"
                            label="title"/>
                    </div>
                    <div class="col-2" v-if="book_type == 'items_book'">
                      <label for="number_from">Numurs no</label>
                      <input type="text" id="number_from" name="number_from" v-model="number_from" class="form-control">
                    </div>
                  <div class="col-2" v-if="book_type == 'items_book'">
                    <label for="number_to">Numurs līdz</label>
                    <input type="text" id="number_to" name="number_to" v-model="number_to" class="form-control">
                  </div>
                    <div class="col-2" >
                        <div class="form-group">
                            <label for="date_from">Datums no</label>
                            <v-date-picker
                                :popover="{ visibility: 'click' }"
                                mode="single"
                                v-model="date_from"
                                :type="'date'"
                                :locale="'LV'"
                                color="teal"
                                :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                            />
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label for="date_from">Datums līdz</label>
                            <v-date-picker
                                :popover="{ visibility: 'click' }"
                                mode="single"
                                v-model="date_to"
                                :type="'date'"
                                :locale="'LV'"
                                color="teal"
                                :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                            />
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="actions">
                            <form action="/registration-books/get" method="POST">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="hidden" name="book_type" :value="book_type">
                                <input type="hidden" name="ciphers" :value="ciphers">
                                <input type="hidden" name="number_from" :value="number_from">
                                <input type="hidden" name="number_to" :value="number_to">
                                <input type="hidden" name="date_from" :value="JSON.stringify(date_from)">
                                <input type="hidden" name="date_to" :value="JSON.stringify(date_to)">
                                <button class="btn btn-primary" formtarget="_blank">Izgūt grāmatu (PDF)</button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    props:['item_ciphers'],
    data()
    {
        return {
            ciphers:"",
            book_type:"items_book",
            date_from:"",
            date_to:"",
            number_from:"",
            number_to:"",
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')

        }
    },
}
</script>

<style lang="scss">
.actions{
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
}

</style>
